import React, { useEffect, useRef, useState, useCallback } from "react";
import {
  Select,
  Input,
  Form,
  Row,
  Col,
  Card,
  message,
  Tabs,
  Button,
  DatePicker,
  Modal,
  Spin,
  Tree,
} from "antd";
import polyline from "@mapbox/polyline";
import { CALL_API } from "../../../Common/api";
import { ReactComponent as IntelSearch } from "../../../../src/assets/images/Frame 1233.svg";
import { ReactComponent as Back } from "../../../../src/assets/images/lets-icons_back.svg";
import { ReactComponent as Loc } from "../../../../src/assets/images/P_LOC.svg";
import { ReactComponent as Home } from "../../../../src/assets/images/P_HOME.svg";
import { ReactComponent as Two } from "../../../../src/assets/images/2.svg";
import {
  ButtonFilled,
  Buttontransparent,
} from "../../../Reusablecomponents/UIButtons";
import { useDispatch, useSelector } from "react-redux";
import { SearchOutlined, CalendarOutlined } from "@ant-design/icons";
import styled from "styled-components";
import GoogleMapComponent from "../../../Reusablecomponents/GoogleMapComponent";
import { useNavigate, useLocation } from "react-router-dom";

const Styledashboard = styled.div`
  .title {
    font-weight: 600;
    font-style: Semi Bold;
    font-size: 18px;
    color: #3d3d3d;
    height: 17px;
    margin-top: 6px;
  }
  .subtitle {
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    color: #6f6c6c;
  }
  .custom-tabs .ant-tabs-tab {
    color: #b3b3b3 !important;
  }

  .custom-tabs .ant-tabs-tab.ant-tabs-tab-active {
    color: #06ce06 !important;
  }
  .box {
    border: 1px solid #e0e0e0; /* correct border syntax */
    border-radius: 6px;
    padding: 14px 10px;
    margin-bottom: 16px; /* add some spacing between sections */
    background: #fff; /* keep it white for card look */
  }
  .mapcomponent_subcontainer {
    height: calc(100vh - 100px); /* adjust header/footer */
    width: 100%;
    position: relative;
  }
  .container_for_header_subtwo {
    display: flex;
    align-items: center; /* Ensures all items align properly */
    gap: 10px; /* Adds spacing between elements */
    flex-wrap: wrap;
  } /* Remove padding around the prefix & input */
  .route-form-style .ant-input-affix-wrapper {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    border-radius: 5px !important;
  }

  /* Reduce gap between icon & text */
  .route-form-style .ant-input-affix-wrapper .ant-input-prefix {
    margin-right: 4px !important;
    padding: 0 !important;
  }

  /* Adjust input text padding to be visually centered */
  .route-form-style .ant-input-affix-wrapper input.ant-input {
    padding-left: 4px !important;
  }
  /* Style only the icon/button on the right */
  .green-search-icon .ant-input-search-button {
    background: #06ce06 !important;
    border-color: #06ce06 !important;
    color: white !important;
  }

  /* Make hover consistent */
  .green-search-icon .ant-input-search-button:hover {
    background: #05b605 !important;
    border-color: #05b605 !important;
  }

  /* Remove padding around the prefix & input */
  .route-form-style .ant-input-affix-wrapper {
    padding-left: 0 !important;
    padding-right: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
    border-radius: 5px !important;
  }

  /* Reduce gap between icon & text */
  .route-form-style .ant-input-affix-wrapper .ant-input-prefix {
    margin-right: 4px !important;
    padding: 0 !important;
  }

  /* Adjust input text padding to be visually centered */
  .route-form-style .ant-input-affix-wrapper input.ant-input {
    padding-left: 4px !important;
  }
  /* Style only the icon/button on the right */
  .green-search-icon .ant-input-search-button {
    background: #06ce06 !important;
    border-color: #06ce06 !important;
    color: white !important;
  }

  /* Make hover consistent */
  .green-search-icon .ant-input-search-button:hover {
    background: #05b605 !important;
    border-color: #05b605 !important;
  }
  /* Remove unwanted spacing before prefix icon */
  .custom-search .ant-input-prefix {
    margin-right: 6px !important; /* Keep small gap between icon & text */
    margin-left: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
    padding-left: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  /* Remove internal padding on input caused by prefix */
  .custom-search.ant-input-affix-wrapper {
    padding-left: 0 !important;
    padding-top: 0 !important;
    padding-bottom: 0 !important;
  }

  @media (min-width: 1026px) and (max-width: 1440px) {
    .mapboxgl-map {
      width: 30%;
    }
    .container_map_component {
      background-color:;
      flex-direction: column !important;
    }
    .container_map_subcomponent {
      max-width: 100% !important ;
      flex: 100% !important;
      margin: 9px 0px 9px 0px;
    }
    .map_container_three {
      width: 100% !important ;
    }
  }
  @media (max-width: 768px) {
    .mapboxgl-map {
      width: 40%;
      border-radius: 12px;
    }
  }

  @media (max-width: 1024px) {
    .mapboxgl-map {
      width: 40%;
    }
    .container_map_component {
      background-color:;
      flex-direction: column !important;
    }
    .container_map_subcomponent {
      max-width: 100% !important ;
      flex: 100% !important;
      margin: 9px 0px 9px 0px;
    }
  }
`;
const { Option } = Select;
const { TabPane } = Tabs;
const { RangePicker } = DatePicker;
function RouteDetails() {
  const [form] = Form.useForm();
  const RouteType = [
    {
      name: "Fixed Route",
      value: 0,
    },
    {
      name: "Streamline Route",
      value: 1,
    },
  ];
  const [activeSubTab, setActiveSubTab] = useState("Intelligent");
  const isIntelligent = activeSubTab === "Intelligent";
  const isTrack = activeSubTab === "Track";
  const location = useLocation();
  const mode = location.state?.mode || "view"; // "add" | "edit" | "view"
  const [loading, setLoading] = useState(false);
  const [activeTab, setActiveTab] = useState("1");
  const [fenceList, setFenceList] = useState([]);
  const [isEditing, setIsEditing] = useState(mode === "add" || mode === "edit");
  const [companyList, setCompanyList] = useState([]);
  const [routesMap, setRoutesMap] = useState([]);
  const [assetList, setAssetList] = useState([]);
  // const [fencesList, setFencesList] = useState([]);
  const fencesList = useSelector((state) => state?.authTracking?.fenceList);
  const { FGUID } = location.state || {};
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedAsset, setSelectedAsset] = useState(null);
  const [selectedFences, setSelectedFences] = useState([]);
  const [StartFence, setStartFence] = useState([]);
  const [EndFence, setEndFence] = useState([]);
  const [RoadPoints, setRoadPoints] = useState([]);
  const [FPassFenceGUID, setFPassFenceGUID] = useState([]);
  const [fencesLoaded, setFencesLoaded] = useState(false);
  const navigate = useNavigate();

  const handleSave = async () => {
    try {
      const values = form.getFieldsValue(); // get form values

      // --- LOGIC FOR FENCE DATA CALCULATION ---
      const firstFence = mapFencesData[0]?.FGUID || "";
      const lastFence = mapFencesData[mapFencesData?.length - 1]?.FGUID || "";
      const passFences = getMiddleFGUIDs(mapFencesData) || "";
      // const roadPoints = mergeFPaths(mapFencesData);
      const roadPoints =
        roadPointsRef.current.length > 0 ? roadPointsRef.current : [];

      if (!roadPoints.length) {
        message.warning("Please calculate distance before saving.");
        return;
      }
      // map values to API structure
      const formData = {
        rtype: values.routeType,
        dates: values.selectDates,
        asset: values.selectAsset,
        distance: values.totalDistance,
        time: values.transportTime,
        rname: values.routeName,
        rcode: values.routeCode,
        desc: values.description,
        //update
        FStartFence: firstFence,
        FEndFence: lastFence,
        FPassFenceGUIDs: passFences,
        FRoadPoints: roadPoints,
      };

      if (mode === "add") {
        await createRoutes(formData);
      } else {
        // updating → FGUID comes from existing record
        await updateRoute(formData, fenceList?.FGUID);
      }
      setIsEditing(false);
      navigate("/Route");
    } catch (err) {
      console.error("Error saving fence:", err);
    }
  };
  useEffect(() => {
    // Load route details immediately in edit mode; do not wait for fences
    if (mode === "edit" && FGUID) {
      routeMap(FGUID);
    }
  }, [mode, FGUID]);

  const routeMap = async (FGUID) => {
    try {
      setLoading(true);
      const { data, ResponseCode } = await CALL_API(
        "POST",
        "routes/route-details",
        {
          FGUID: FGUID,
          FTokenID: "05463e39-8da7-479f-9377-c990bd17f76c",
        },
      );

      const route = data?.route?.Table[0];
      if (!route) throw new Error("Route not found");

      setRoutesMap(route);
      setStartFence(route.FStartFence || "");
      setEndFence(route.FEndFence || "");

      const roadPoints = route.FRoadPoints ? JSON.parse(route.FRoadPoints) : [];
      setRoadPoints(roadPoints.length ? JSON.stringify(roadPoints) : "[]");

      const passFenceGUID =
        route.FRoutePassInfo && route.FRoutePassInfo.length
          ? route.FRoutePassInfo.map((item) => item.FPassFenceGUID).join(",")
          : "";
      setFPassFenceGUID(passFenceGUID);

      // Set selected fences
      const startFenceId = route.FStartFence || "";
      const endFenceId = route.FEndFence || "";
      const passFenceIds = (route.FRoutePassInfo || [])
        .map((fence) => fence.FPassFenceGUID)
        .filter(Boolean);

      const combined = [startFenceId, ...passFenceIds, endFenceId].filter(
        Boolean,
      );
      const uniqueSelected = Array.from(new Set(combined));
      // Preselect in UI immediately even if full fence list isn't fetched yet
      setSelectedFences(uniqueSelected);
      // Set route geometry if available
      if (roadPoints.length > 1) {
        roadPointsRef.current = roadPoints; // loaded road points
        setRouteGeoJSON({
          type: "LineString",
          coordinates: roadPoints.map((p) => [Number(p.lng), Number(p.lat)]),
        });
      } else {
        setRouteGeoJSON(null);
      }
    } catch (error) {
      console.error("Error loading route details:", error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAllCompany = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("GET", "container/getAllCompany");
      setCompanyList(data?.companies || []);
    } catch (error) {
      console.error("[fetchAllCompany] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    fetchAllCompany();
    fetchAssetList();
    // fetchFenceList();
  }, []);
  const fetchAssetList = useCallback(async () => {
    try {
      setLoading(true);
      const { data } = await CALL_API("POST", "routes/routeAssetList", {
        FAgentGUID: userInfo?.ECTSCompId,
      });
      setAssetList(data);
    } catch (error) {
      console.error("[fetchAssetList] error:", error);
    } finally {
      setLoading(false);
    }
  }, []);
  // const fetchFenceList = useCallback(async () => {
  //   try {
  //     setLoading(true);
  //     const { data } = await CALL_API("POST", "/routes/routeFenceList", {
  //       FAgentGUID: userInfo?.ECTSCompId,
  //       FPageIndex: 1,
  //       FPageSize: 1000,
  //     });
  //     if (data?.Table1) {
  //       setFencesList(data.Table1);
  //       setFencesLoaded(true); // mark as loaded
  //     }
  //   } catch (error) {
  //     console.error("[fetchFenceList] error:", error);
  //     setFencesLoaded(false);
  //   } finally {
  //     setLoading(false);
  //   }
  // }, []);
  const openAssetModal = async () => {
    await fetchAssetList(); // your API call
    setIsModalVisible(true);
  };

  const handleSelectAsset = (node) => {
    if (node.isLeaf) {
      setSelectedAsset(node.title.split(" [")[0]); // Extract name from title if needed
      form.setFieldsValue({
        selectAsset: node.title.split(" [")[0], // Set only the name in the form
      });
      setIsModalVisible(false); // Close the modal
    }
  };

  const formatAssetsToTree = (assets) => {
    return assets?.map((company) => ({
      title: company.FName,
      key: company.FGUID,
      children: company.FChild.map((group) => ({
        title: group.FName,
        key: group.FGUID,
        children: group.FChild
          ? group.FChild.map((device) => ({
              title: `${device.FName} [${device.FCar?.ID || "unknown"}]`,
              key: device.FGUID,
              isLeaf: true,
            }))
          : [],
      })),
    }));
  };
  // Toggle selection when a card is clicked

  const handleFenceClick = (fenceId) => {
    setSelectedFences(
      (prevSelected) =>
        prevSelected.includes(fenceId)
          ? prevSelected.filter((id) => id !== fenceId) // deselect
          : [...prevSelected, fenceId], // select
    );
  };
  const mapFencesData = selectedFences
    .map((fguid) => fencesList.find((fence) => fence.FGUID === fguid))
    .filter(Boolean);
  useEffect(() => {
    if (location.state && companyList?.length) {
      setFenceList(location.state);
      // Update form values when fenceList changes
      form.setFieldsValue({
        routeType: location.state.FRouteType || 0,
        selectDates: location.state.selectDates || "",
        asset: location.state.selectAsset || "",
        totalDistance: location.state.FDistance || 0,
        transportTime: location.state.FDuration || 0,
        routeName: location.state.FName || "",
        routeCode: location.state.FCode || "",
        description: location.state.description || "",
      });
    }
  }, [location.state, form, companyList]);
  useEffect(() => {
    form.resetFields();
  }, [mode, location.key]);

  const getMiddleFGUIDs = (arr) => {
    if (!arr || arr.length <= 2) return ""; // nothing or only first & last

    const middleItems = arr.slice(1, arr.length - 1); // skip first & last
    return middleItems.map((item) => item.FGUID).join(",");
  };

  const mergeFPaths = (arr) => {
    if (!arr?.length) return [];

    const merged = [];

    arr.forEach((item, i) => {
      try {
        const path = JSON.parse(item.FPath);
        merged.push(...(i === 0 ? path : path.slice(1)));
      } catch {
        console.error("Invalid FPath:", item.FPath);
      }
    });

    return merged;
  };
  const getCurrentDateTimeCode = () => {
    const now = new Date();

    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, "0");
    const day = String(now.getDate()).padStart(2, "0");
    const hours = String(now.getHours()).padStart(2, "0");
    const minutes = String(now.getMinutes()).padStart(2, "0");
    const seconds = String(now.getSeconds()).padStart(2, "0");

    return `${year}${month}${day}${hours}${minutes}${seconds}`;
  };

  // usage in your payload

  const createRoutes = useCallback(async (formData) => {
    try {
      setLoading(true);
      const lastItem = mapFencesData[mapFencesData?.length - 1];
      const { data, ResponseCode, message } = await CALL_API(
        "POST",
        "routes/addroute",
        {
          FName: formData.rname,
          FCode: getCurrentDateTimeCode(),
          FDistance: Number(formData.distance),
          FDuration: Number(formData.time),
          FCaseCode: 1,
          FRemark: formData.desc || "",
          FAgentGUID: userInfo?.ECTSCompId,
          FStartFence: formData.FStartFence,
          FEndFence: formData.FEndFence,
          FPassFenceGUIDs: formData.FPassFenceGUIDs,
          FRouteType: formData.rtype,
          FBindRouteGUIDs: "",
          FRoadPoints: formData.FRoadPoints,
        },
      );
      if (ResponseCode === 200) {
        setLoading(false);
        message.success("Route created successfully!");
        navigate("/Route");
      } else {
        setLoading(false);
        console.warn("Creation failed", data);
        message.error(message);
      }
    } catch (error) {
      console.error("[createRoutes] error:", error);
    } finally {
      setLoading(false);
    }
  });

  const updateRoute = useCallback(
    async (formData, FGUID) => {
      try {
        setLoading(true);

        const { ResponseCode, message: apiMessage } = await CALL_API(
          "POST",
          "routes/updateroute",
          {
            FName: formData.rname || "",
            FCode: formData.rcode || "",
            FDistance: formData.distance || 0,
            FDuration: formData.time || 0,
            FCaseCode: 1,
            FRemark: formData.desc || "",
            FAgentGUID: userInfo.ECTSCompId || "",
            FStartFence: formData.FStartFence,
            FEndFence: formData.FEndFence,
            FPassFenceGUIDs: formData.FPassFenceGUIDs,
            FRouteType: formData.rtype || 0,
            FBindRouteGUIDs: "",
            FRoadPoints: formData.FRoadPoints,
            FGUID: FGUID,
          },
        );

        if (ResponseCode === 200) {
          message.success("Route updated successfully!");
          navigate("/Route");
        } else {
          message.error(apiMessage || "Update failed");
        }
      } catch (error) {
        console.error("[updateRoute] error:", error);
      } finally {
        setLoading(false);
      }
    },
    [navigate, userInfo?.ECTSCompId],
  );

  // For add mode, empty form, else fill with initialValues
  const getInitialFormValues = (data = {}) => ({
    routeType: data.FRouteType || 0,
    selectDates: data.selectDates || "",
    asset: data.selectAsset || "",
    totalDistance: data.FDistance / 1000 || 0,
    transportTime: data.FDuration || 0,
    routeName: data.FName || "",
    routeCode: data.FCode || "",
    description: data.description || "",
  });

  const initialValues = mode === "add" ? {} : getInitialFormValues(fenceList);

  useEffect(() => {
    if (mode === "add") {
      form.setFieldsValue({});
    } else if (location.state && companyList?.length) {
      setFenceList(location.state);
      form.setFieldsValue(getInitialFormValues(location.state));
    }
  }, [mode, location.state, form, companyList]);
  const [searchTerm, setSearchTerm] = useState("");
  const filteredFences = fencesList.filter((fence) =>
    fence.FName.toLowerCase().includes(searchTerm.toLowerCase()),
  );
  // Sort to keep selected fences at the top in edit mode
  const sortedFences = React.useMemo(() => {
    // Selected fences in user order
    const selected = selectedFences
      .map((fguid) => filteredFences.find((f) => f.FGUID === fguid))
      .filter(Boolean);
    // Unselected fences, sorted alphabetically
    const unselected = filteredFences
      .filter((f) => !selectedFences.includes(f.FGUID))
      .sort((a, b) => (a.FName || "").localeCompare(b.FName || ""));
    return [...selected, ...unselected];
  }, [filteredFences, selectedFences]);

  const [distance, setDistance] = useState([]);
  const [routeGeoJSON, setRouteGeoJSON] = useState(null);
  const roadPointsRef = useRef([]);

  const handleSearchDistance = async () => {
    if (mapFencesData.length < 2) {
      if (mode === "add" || (mode === "edit" && !routesMap?.FRoadPoints)) {
        message.error("Select at least two fences to calculate distance.");
        return;
      }
    }

    try {
      setLoading(true);

      let points = mapFencesData.map((f) => ({
        lat: f.FCenterLat,
        lng: f.FCenterLon,
      }));

      if (points.length < 2) {
        message.error("Need at least two valid points.");
        return;
      }

      const origin = `${points[0].lat},${points[0].lng}`;
      const destination = `${points[points.length - 1].lat},${points[points.length - 1].lng}`;
      const waypoints = points.slice(1, -1).map((p) => `${p.lat},${p.lng}`);

      const { data } = await CALL_API("POST", "routes/calculateDistance", {
        origin,
        destination,
        waypoints,
      });

      if (!data.routes || !data.routes.length) {
        message.error("No route found.");
        return;
      }

      const routePolyline = data.routes[0].overview_polyline.points;
      const distanceInMeters = data.routes[0].legs.reduce(
        (sum, leg) => sum + leg.distance.value,
        0,
      );
      const distanceInKm = (distanceInMeters / 1000).toFixed(2);

      setDistance(distanceInKm);
      form.setFieldsValue({ totalDistance: distanceInKm });

      // Decode the polyline for map drawing
      const decodedPath = polyline
        .decode(routePolyline)
        .map(([lat, lng]) => ({ lat, lng })); //polyline.decode returns [lat, lng]

      roadPointsRef.current = decodedPath; //store in ref immediately

      setRouteGeoJSON({
        type: "LineString",
        coordinates: decodedPath.map(({ lat, lng }) => [lng, lat]),
      });
    } catch (error) {
      console.error(error);
      message.error("Failed to calculate distance.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Styledashboard>
      <div style={{ padding: "16px", background: "#f0f2f5" }}>
        <Row gutter={[0, 16]} style={{ margin: 0 }}>
          {/* Left White Box */}
          <Col
            style={{
              flex: "0 0 350px",
              maxWidth: 350,
              minWidth: 350,
              paddingRight: 0,
              paddingLeft: 0,
            }}
          >
            {" "}
            <Card
              style={{ borderRadius: "12px", height: "100%", width: "100%" }}
            >
              <div className="container_for_header_subtwo">
                <Back
                  style={{ cursor: "pointer" }}
                  onClick={() => navigate("/Route")}
                />{" "}
                <p className="title">
                  {mode === "add"
                    ? "Create Route"
                    : isEditing
                      ? "Edit Route"
                      : "Details"}
                </p>
              </div>
              <p className="subtitle">
                {!initialValues?.routeName
                  ? "Add New Route"
                  : initialValues?.routeName}
              </p>{" "}
              <div className="custom-tabs">
                <Tabs activeKey={activeTab} onChange={setActiveTab}>
                  <TabPane tab="Fence List" key="1">
                    {/* Fence List Content */}
                    <div style={{ padding: "16px" }}>
                      <div
                        style={{
                          display: "flex",
                          gap: "8px",
                          marginBottom: "16px",
                        }}
                      >
                        <Input
                          className="custom-search"
                          placeholder="Search fence"
                          prefix={
                            <IntelSearch
                              style={{
                                cursor: "pointer",
                              }}
                            />
                          }
                          style={{ marginBottom: "10px" }}
                          value={searchTerm}
                          onChange={(e) => setSearchTerm(e.target.value)}
                        />

                        <Button
                          type="primary"
                          style={{
                            background: "#06CE06",
                            color: "black",
                            cursor: "pointer",
                          }}
                          onClick={() =>
                            navigate("/GeoDetails", { state: { mode: "add" } })
                          }
                        >
                          + Add
                        </Button>
                      </div>

                      {/* Fence List Container with Scroll */}
                      <div
                        style={{
                          maxHeight: "600px",
                          overflowY: "auto",
                          paddingRight: "8px",
                        }}
                      >
                        {loading ? (
                          <Spin loading={loading} />
                        ) : (
                          sortedFences.map((fence) => {
                            const isSelected = selectedFences.includes(
                              fence.FGUID,
                            );
                            return (
                              <div
                                key={fence.FGUID}
                                onClick={() => handleFenceClick(fence.FGUID)}
                                style={{
                                  background: isSelected ? "#06CE06" : "#fff",
                                  color: isSelected ? "#fff" : "#000",
                                  padding: "16px",
                                  borderRadius: "8px",
                                  marginTop: "20px",
                                  cursor: "pointer",
                                  border: "1px solid #ccc",
                                }}
                              >
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <strong
                                    style={{
                                      color: "#000",
                                      fontWeight: 500,
                                      fontSize: "14px",
                                    }}
                                  >
                                    {fence.FName}
                                  </strong>
                                  <input
                                    type="checkbox"
                                    checked={isSelected}
                                    readOnly
                                    style={{ transform: "scale(1.5)" }}
                                  />
                                </div>
                                <p>{fence.FAddress}</p>
                                <div
                                  style={{
                                    background: isSelected ? "#fff" : "#f0f0f0",
                                    color: isSelected ? "#000" : "#333",
                                    padding: "4px 8px",
                                    borderRadius: "12px",
                                    width: "fit-content",
                                  }}
                                >
                                  {fence.FFenceTypeName}
                                </div>
                              </div>
                            );
                          })
                        )}
                      </div>
                    </div>
                  </TabPane>

                  <TabPane tab="Route Details" key="2">
                    {/* Route Details Form */}
                    <div style={{ padding: "16px" }}>
                      <Form
                        layout="vertical"
                        form={form}
                        initialValues={initialValues}
                        className="route-form-style"
                      >
                        <Form.Item label="Route type" name="routeType">
                          <Select
                            disabled={!isEditing}
                            className="w-100"
                            showSearch
                            optionFilterProp="children"
                            allowClear
                            filterOption={(input, option) =>
                              option?.children
                                ?.toLowerCase()
                                .includes(input.toLowerCase())
                            }
                          >
                            {RouteType?.map((item) => (
                              <Option key={item.value} value={item.value}>
                                {item.name}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>

                        {/* Sub Tabs */}
                        <Tabs
                          defaultActiveKey="Intelligent"
                          onChange={setActiveSubTab}
                        >
                          <TabPane tab="Intelligent" key="Intelligent" />
                          <TabPane tab="Custom" key="Custom" />
                          <TabPane tab="Track" key="Track" />
                        </Tabs>

                        {/* Conditionally Render Fields */}
                        {isTrack ? (
                          <>
                            <Form.Item label="Select Dates" name="selectDates">
                              <RangePicker
                                disabled={!isEditing}
                                style={{ width: "100%" }}
                                placeholder={["Start date", "End date"]}
                                suffixIcon={<CalendarOutlined />}
                              />
                            </Form.Item>

                            <Form.Item label="Select Asset" name="selectAsset">
                              <Input
                                disabled={!isEditing}
                                placeholder="Select Asset"
                                value={selectedAsset?.FName}
                                readOnly
                                prefix={
                                  <IntelSearch
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={openAssetModal}
                                  />
                                }
                              />
                            </Form.Item>
                          </>
                        ) : (
                          <Form.Item
                            label="Total Distance (Km)"
                            name="totalDistance"
                          >
                            <Input
                              disabled={!isEditing}
                              placeholder="Enter distance"
                              prefix={
                                isIntelligent ? (
                                  <IntelSearch
                                    style={{
                                      cursor: "pointer",
                                    }}
                                    onClick={handleSearchDistance}
                                  />
                                ) : null
                              }
                            />
                          </Form.Item>
                        )}

                        {/* Common Fields */}
                        <Form.Item
                          label="Transport Time (Hour)"
                          name="transportTime"
                        >
                          <Input
                            placeholder="Enter time"
                            disabled={!isEditing}
                          />
                        </Form.Item>

                        <Form.Item label="Route Name" name="routeName">
                          <Input
                            placeholder="Route name"
                            disabled={!isEditing}
                          />
                        </Form.Item>

                        <Form.Item label="Route Code" name="routeCode">
                          <Input
                            placeholder="Auto-generated code"
                            disabled={!isEditing}
                          />
                        </Form.Item>

                        <Form.Item label="Description" name="description">
                          <Input.TextArea
                            rows={3}
                            placeholder="Description"
                            disabled={!isEditing}
                          />
                        </Form.Item>

                        {/* Buttons */}
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                          }}
                        >
                          <Buttontransparent onClick={() => form.resetFields()}>
                            Reset
                          </Buttontransparent>
                          <ButtonFilled
                            type="primary"
                            loading={loading}
                            onClick={handleSave}
                          >
                            Save
                          </ButtonFilled>
                        </div>
                      </Form>
                    </div>
                  </TabPane>
                </Tabs>
              </div>
            </Card>
          </Col>

          {/* Right White Box */}
          <Col
            style={{ flex: 1, minWidth: 0, paddingLeft: 15, paddingRight: 0 }}
          >
            <div className="mapcomponent_subcontainer">
              <GoogleMapComponent
                showSearch={true}
                className="map_container_three"
                routeData={mode === "add" ? mapFencesData : routesMap}
                mapSize="large"
                rGeoJSON={routeGeoJSON}
                fencesList={fencesList}
                selectedFences={selectedFences}
                mode={mode}
              />
            </div>
          </Col>
        </Row>
      </div>
      <Modal
        title="Select device"
        open={isModalVisible}
        footer={null}
        onCancel={() => setIsModalVisible(false)}
        width={400}
      >
        <Tree
          showLine
          defaultExpandAll
          treeData={formatAssetsToTree(assetList)}
          onSelect={(selectedKeys, info) => {
            if (info.node.isLeaf) {
              handleSelectAsset(info.node);
            }
          }}
        />
      </Modal>
    </Styledashboard>
  );
}

export default RouteDetails;
